<a mat-list-item
   [routerLink]="_routerLink"
   routerLinkActive="{{ hasSubItems ? null : !isSubpage ? 'active-link' : 'subpage-active-link'}}"
   [routerLinkActiveOptions]="isActiveMatchOptions"
   [queryParams]="_queryParams"
   #rla="routerLinkActive"
   class="list-item"
   [ngClass]="{'cursor-pointer': isSubpage}"
   matTooltip="{{ collapsed ? label : null }}">
  <div class="position-absolute w-100 h-100 d-block overlay" *ngIf="hasSubItems" (click)="onClick($event)"></div>
  <div class="{{ 'ms-' + level * 2 }}">
    <div class="d-flex">
      <mat-icon *ngIf="icon"
                mat-list-icon
                color="{{ rla.isActive && !hasSubItems ? 'accent' : 'primary'}}"
                [class.me-1]="!collapsed">
        {{ icon }}
      </mat-icon>
      <span *ngIf="!collapsed" class="mobileView">{{ label }}</span>
      <ng-container *ngIf="hasSubItems">
        <div class="flex-fill"></div>
        <mat-icon>{{ (rla.isActive  || expanded) ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
      </ng-container>
    </div>
  </div>
</a>
<div *ngIf="hasSubItems && (rla.isActive || expanded)">
  <ng-content></ng-content>
</div>
